import { inject } from '@angular/core';
import { ActivatedRoute, Params } from '@angular/router';
import { map, Observable, switchMap } from 'rxjs';
import { RankService } from '@rank/infra';
import { GetUserRankPathParams, GetUserRankResponse } from '@core-http';
import { GetUserRankQueryResult } from './get-user-rank.query-result';

export class GetUserRankQueryHandler {
  private readonly rankService: RankService = inject(RankService);
  private readonly activatedRoute: ActivatedRoute = inject(ActivatedRoute);

  getUserRank(): Observable<GetUserRankQueryResult> {
    return this.activatedRoute.params.pipe(
      switchMap((params: Params) => {
        const pathParams: GetUserRankPathParams = { userId: params['id'] };
        return this.rankService.getUserRank(pathParams);
      }),
      map((dto: GetUserRankResponse) => this.mapToQueryResult(dto))
    );
  }

  private mapToQueryResult(dto: GetUserRankResponse): GetUserRankQueryResult {
    return {
      userId: dto.userId,
      displayName: dto.displayName,
      thumbnail: dto.thumbnail,
      points: dto.points,
      rank: dto.rank,
      totalUsers: dto.totalUsers
    };
  }
}
